import { createClient } from '@supabase/supabase-js'

// Use env vars for deployment and multi-environment (Vue CLI: VUE_APP_*)
const DB_URL = process.env.VUE_APP_SUPABASE_URL || ''
const API_KEY = process.env.VUE_APP_SUPABASE_ANON_KEY || ''
export const supabase = createClient(DB_URL, API_KEY)



